import * as React from 'react'
import connect from 'react-redux/es/connect/connect'
import { authorizeUser, userSignInCallback, setInitUrl, get_active_user } from 'actions/Auth'
import { Redirect } from 'react-router-dom'
import { checkAuthentication } from 'util/checkAuthentication'
import debug from 'debug'
import { LoginForm } from '../components/Login'
import AppMainContainer from './AppMainContainer'

const signInDebug = debug('linkgua:auth:signin')

class SignIn extends React.Component {

  constructor (props, context) {
    super(props, context)
    signInDebug('creating sign in component')

    if (location.hash) {
      signInDebug('hash present, handling callback')
      this.props.userSignInCallback(location.hash, '/')
    }
  }

  render () {
    signInDebug('render')
    const { authUser, signInPending, authorizeUser, initUrl } = this.props

    if (signInPending) {
      signInDebug('render: sign in pending - no render for me')
      return null
    }

    // if sent to sign in but already authenticated, send into app instead
    if (checkAuthentication(authUser)) {
      const redirectTo = initUrl ? initUrl : '/'
      signInDebug('render: auth ok, redirecting', redirectTo)
      return (<Redirect to={redirectTo}/>)
    }

    signInDebug('render: login')
    return (
      <AppMainContainer>
        <LoginForm renderAs='signIn' onAuthenticationRequested={ (email) => { authorizeUser(email) } }/>
      </AppMainContainer>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {authUser, signInPending, initUrl} = auth
  return {authUser, signInPending, initUrl }
}

export default connect(mapStateToProps, {
  authorizeUser,
  get_active_user,
  userSignInCallback,
  setInitUrl
})(SignIn)



// WEBPACK FOOTER //
// ./Linkgua/containers/SignIn.js